
export const ubiznewsEmail = 'contact@ubiznewstv.com';
export const ubiznewsTel = '';
export const ubiznewsLocation = '';
export const ubiznewsLocationLink = '';
export const ubiznewsFacebook = 'https://www.facebook.com/Ubiznews?locale=fr_FR';
export const ubiznewsInstagram = 'https://www.instagram.com/ubiznewstvom5/';
export const ubiznewsYoutube = 'https://www.youtube.com/user/UBIZNEWS';
export const ubiznewsLinkedIn = 'https://www.linkedin.com/company/ubiznews/';
export const ubiznewsTwitter = 'https://x.com/ubiznews';


export const playerLink = "https://geo.dailymotion.com/player.html?video=x8dicii"